// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React, { useState } from 'react';
import { navigate } from 'hookrouter';
import {auth} from '../actions';
import { useDispatch } from 'react-redux'
import { COLOR } from '../const'


const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [valid, setValid] = useState(false)
  const user = 'adminpw'
  const pass = 'tafukillbill3'

  const dispatch = useDispatch();
  
  const checkLogin = () => {
    if (username === user && password === pass) {
      dispatch(auth('test'))
      navigate('/route')
    } else {
      setValid(true)
    }
  }
  return (
    <>
      <section className={styles.form}>
        <h2 className={styles.h2}>Login To Your Account</h2>
        {valid ? <p className={styles.error}>Error. Please enter correct Username &amp; password.</p> : null}
        <input className={styles.input}
          placeholder="Username" type="text"
          value={username}
          onChange={(e) => {
            setValid(false);
            setUsername(e.target.value)
          }}
        />
        <input className={styles.input}
          placeholder="Password"
          type="password" value={password}
          onChange={(e) => {
            setValid(false);
            setPassword(e.target.value)
          }} />
        <button className={styles.button} onClick={checkLogin}>Login</button>
      </section>

    </>
  );
}

const styles = {
  root: css`
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 25px 50px 0 rgba(0, 0, 0, 0.1);
    // font-family: system-ui;
    margin: 0 auto;
    padding: 35px 24px 24px 24px;
    width: 90%;
  `,
  h2: css`
  margin: 0 0 20px;
  line-height: 1;
  color: ${COLOR['DARK_1']};
  font-size: 18px;
  font-weight: 400;
  `,
  form: css`
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  width: 285px;
  margin: -140px 0 0 -182px;
  padding: 40px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  `,
  input: css`
  outline: none;
  display: block;
  width: 100%;
  margin: 0 0 20px;
  padding: 10px 15px;
  border: 1px solid ${COLOR['PLACEHOLDER']};
  color:${COLOR['PLACEHOLDER']};
  font-family: "Roboto";
  box-sizing: border-box;
  font-size: 14px;
  font-wieght: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: 0.2s linear;
  &:focus {
    color: ${COLOR['DARK_1']};
    border: 1px solid  ${COLOR['DARK_1']};
  }
  `,
  button: css`
  cursor: pointer;
  background: ${COLOR['YELLOW_1']};
  width: 100%;
  padding: 10px 15px;
  border: 0;
  color: #fff;
  font-family: "Roboto";
  font-size: 14px;
  font-weight: 400;
  &:hover {
    background: ${COLOR['YELLOW_1']};
  }
  `,
  error: css`
  color: #e41313;
  font-size: 12px;
  `,
};
export default Login;
